module.exports = __webpack_public_path__ + "static/media/Maf_ANTP.7f60760a.jpg";